<template>
	<!--**********************************
			Main wrapper start
		***********************************-->
	<div id="main-wrapper">
	  <!--**********************************
	  Content body start
  ***********************************-->
  
  <div class="content-body">
			<div class="container-fluid">
				<!-- Add Project -->
				<!-- <div class="modal fade" id="addProjectSidebar">
					<div class="modal-dialog" role="document">
						<div class="modal-content">
							<div class="modal-header">
								<h5 class="modal-title">Create Project</h5>
								<button type="button" class="close" data-dismiss="modal"><span>&times;</span>
								</button>
							</div>
							<div class="modal-body">
								<form>
									<div class="form-group">
										<label class="text-black font-w500">Project Name</label>
										<input type="text" class="form-control">
									</div>
									<div class="form-group">
										<label class="text-black font-w500">Deadline</label>
										<input type="date" class="form-control">
									</div>
									<div class="form-group">
										<label class="text-black font-w500">Client Name</label>
										<input type="text" class="form-control">
									</div>
									<div class="form-group">
										<button type="button" class="btn btn-primary">CREATE</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div> -->
                
                <!-- row -->
                <div class="row">
                    <div class="col-lg-12">
                        <div class="profile card card-body px-3 pt-3 pb-0">
                            <div class="profile-head">
                                <div class="photo-content">
                                    <div class="cover-photo"></div>
                                </div>
                                <div class="profile-info">
									<div class="profile-photo">
										<img src="images/profile/profile.png" class="img-fluid rounded-circle" alt="">
									</div>
									<div class="profile-details">
										<div class="profile-name px-3 pt-2">
											<h4 class="text-primary mb-0">{{user ? user.name : 'Admin'}}</h4>
											<!-- <span>UX / UI Designer</span> -->
										</div>
										<div class="profile-email px-2 pt-2">
											<!-- <h4 class="text-muted mb-0"><a href="/cdn-cgi/l/email-protection" class="__cf_email__" data-cfemail="670e09010827021f060a170b024904080a">[email&#160;protected]</a></h4> -->
											<span>{{user ? user.email : 'Email'}}</span>
										</div>
										
									</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



				<div class="row">
          <div class="col-xl-12">
            <div class="card">
              <!-- <div
                class="card-header pb-2 d-block d-sm-flex flex-wrap border-0"
              >
                <div class="d-flex mt-3">
                  <button
                    class="filter-btn up-btn ml-0"
                    data-toggle="modal"
                    data-target="#exampleModal"
                  >
                  {{ lan.admin[13].Account_page[0].Add_new_note}}
                  </button>
                  <button
                    class="filter-btn up-btn"
                    data-toggle="modal"
                    data-target="#exampleModal1"
                  >
                  {{ lan.admin[13].Account_page[0].Add_new_task}}
                  </button>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                      <table v-if="note_detail && note_detail.length" class="pointer">
                        <h5>{{ lan.admin[13].Account_page[0].Notes}}</h5>
                        <tr v-for="(data, index) in note_detail" :key="index" @click="editNote(data.note_id)">
                          <td>
                            <strong>{{ index + 1 }}</strong>
                          </td>
                          <td>
                            <p class="mb-0">{{ data.subject }}</p>
                          </td>
                        </tr>
                      </table>
                    </div>

                    <div class="col-lg-6">
                      <table v-if="task_detail && task_detail.length" class="pointer">
                        <h5>{{ lan.admin[13].Account_page[0].Tasks}}</h5>
                        <tr v-for="(data, index) in task_detail" :key="index" @click="editTask(data.task_id)">
                          <td>
                            <strong>{{ index + 1 }}</strong>
                          </td>
                          <td>
                            <p class="mb-0">{{ data.subject }}</p>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
              </div> -->

              <div class="card-body p-4">
                <div>
                  <div class="row">
                    <div class="col-sm-4 input">
                      <label
                        >{{ lan.admin[14].Contact[0].First_name}}<span>*</span
                        ><span>{{
                          v$.first_name.$error ? " First Name is required" : ""
                        }}</span></label
                      ><br />
                      <input
                        type="text"
                        name="text"
                        v-model="state.first_name"
                        :placeholder="lan.admin[15].Add_contact_page[0].First_name"
                        :class="v$.first_name.$error ? 'input-error' : ''"
                      />
                    </div>

                    <div class="col-sm-4 input">
                      <label
                        >{{ lan.admin[14].Contact[0].Last_name}}<span>*</span>
                        <span>{{
                          v$.last_name.$error ? " Last name is required" : ""
                        }}</span></label
                      ><br />
                      <input
                        type="text"
                        name="text"
                        v-model="state.last_name"
                        :placeholder="lan.admin[15].Add_contact_page[0].Last_name"
                        :class="v$.last_name.$error ? 'input-error' : ''"
                      />
                    </div>

                    <div class="col-sm-4 input">
                      <label>{{ lan.admin[14].Contact[0].Phone}}</label
                      ><br />
                      <input
                        type="text"
                        name="Telephone"
                        v-model="phone"
                        :placeholder="lan.admin[15].Add_contact_page[0].Phone"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-4 input">
                      <label
                        >{{ lan.admin[14].Contact[0].Email}}<span>*</span
                        ><span>{{
                          v$.email.$error ? " Email is required" : ""
                        }}</span></label
                      ><br />
                      <input
                        type="email"
                        name="email"
                        v-model="state.email"
                        :placeholder="lan.admin[15].Add_contact_page[0].Email"
                        :class="v$.email.$error ? 'input-error' : ''"
                      />
                    </div>

                    <!-- <div class="col-sm-4 input">
                      <label
                        >{{ lan.admin[15].Add_contact_page[0].Role}}<span>*</span>
                        <span>{{
                          v$.roles.$error ? " Roles is required" : ""
                        }}</span></label
                      ><br />
                      <select
                        v-model="state.roles"
                        :class="v$.roles.$error ? 'input-error' : ''"
                      >
                        <option value="1">Admin</option>
                        <option value="2">Partner</option>
                        <option value="3">Customer</option>
                      </select>
                    </div> -->

                    <div class="col-sm-4 input">
                      <label>{{ lan.admin[14].Contact[0].Company}}</label
                      ><br />
                      <model-list-select :list="accountDetails"
                style="height: 43px; border: 1px solid #ccc; border-radius: 2px;"
                v-model="company"
                option-value="account_id"
                :custom-text="getName"
                placeholder="Select Company"
                >
              </model-list-select>
                      <!-- <select v-model="company">
                        <option
                          :value="data.account_id"
                          v-for="data in accountDetailsFilter"
                          :key="data.account_id"
                        >
                          {{ data.name }}
                        </option>
                      </select> -->
                    </div>

                    <div class="col-sm-4 input">
                      <label>{{ lan.admin[15].Add_contact_page[0].Mobile_phone}}</label
                      ><br />
                      <input
                        type="text"
                        name="number"
                        v-model="mobile_phone"
                        :placeholder="lan.admin[15].Add_contact_page[0].Mobile_phone"
                      />
                    </div>
                  </div>

                  <textarea
                    name="Address"
                    id="Address"
                    rows="5"
                    v-model="address"
                    :placeholder="lan.admin[15].Add_contact_page[0].Address"
                  ></textarea>

                  <div class="button d-flex justify-content-end mt-4">
                    <button @click="submit" class="search-btn">
                      <div class="lds-ring" v-show="loading">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                      <span v-show="loadingS">{{ lan.admin[15].Add_contact_page[0].Save}}</span>
                    </button>
                    <button class="filter-btn">
                      <router-link to="/contacts">{{ lan.admin[15].Add_contact_page[0].Cancel}}</router-link>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>





                <!-- <div class="row">
                    <div class="col-xl-4">
						<div class="row">
							<div class="col-xl-12">
								<div class="card">
									<div class="card-body">
										<div class="profile-statistics">
											<div class="text-center">
												<div class="row">
													<div class="col">
														<h3 class="m-b-0">150</h3><span>Follower</span>
													</div>
													<div class="col">
														<h3 class="m-b-0">140</h3><span>Place Stay</span>
													</div>
													<div class="col">
														<h3 class="m-b-0">45</h3><span>Reviews</span>
													</div>
												</div>
												<div class="mt-4">
													<a href="javascript:void(0);" class="btn btn-primary mb-1 mr-1">Follow</a> 
													<a href="javascript:void(0);" class="btn btn-primary mb-1" data-toggle="modal" data-target="#sendMessageModal">Send Message</a>
												</div>
											</div>
											
											<div class="modal fade" id="sendMessageModal">
												<div class="modal-dialog modal-dialog-centered" role="document">
													<div class="modal-content">
														<div class="modal-header">
															<h5 class="modal-title">Send Message</h5>
															<button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
														</div>
														<div class="modal-body">
															<form class="comment-form">
																<div class="row"> 
																	<div class="col-lg-6">
																		<div class="form-group">
																			<label class="text-black font-w600">Name <span class="required">*</span></label>
																			<input type="text" class="form-control" value="Author" name="Author" placeholder="Author">
																		</div>
																	</div>
																	<div class="col-lg-6">
																		<div class="form-group">
																			<label class="text-black font-w600">Email <span class="required">*</span></label>
																			<input type="text" class="form-control" value="Email" placeholder="Email" name="Email">
																		</div>
																	</div>
																	<div class="col-lg-12">
																		<div class="form-group">
																			<label class="text-black font-w600">Comment</label>
																			<textarea rows="8" class="form-control" name="comment" placeholder="Comment"></textarea>
																		</div>
																	</div>
																	<div class="col-lg-12">
																		<div class="form-group mb-0">
																			<input type="submit" value="Post Comment" class="submit btn btn-primary" name="submit">
																		</div>
																	</div>
																</div>
															</form>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-xl-12">
								<div class="card">
									<div class="card-body">
										<div class="profile-blog">
											<h5 class="text-primary d-inline">Today Highlights</h5>
											<img src="images/profile/1.jpg" alt="" class="img-fluid mt-4 mb-4 w-100">
											<h4><a href="post-details.html" class="text-black">Darwin Creative Agency Theme</a></h4>
											<p class="mb-0">A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth.</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-xl-12">
								<div class="card">
									<div class="card-body">
										<div class="profile-interest">
											<h5 class="text-primary d-inline">Interest</h5>
											<div class="row mt-4 sp4" id="lightgallery">
												<a href="images/profile/2.jpg" data-exthumbimage="images/profile/2.jpg" data-src="images/profile/2.jpg" class="mb-1 col-lg-4 col-xl-4 col-sm-4 col-6">
													<img src="images/profile/2.jpg" alt="" class="img-fluid">
												</a>
												<a href="images/profile/3.jpg" data-exthumbimage="images/profile/3.jpg" data-src="images/profile/3.jpg" class="mb-1 col-lg-4 col-xl-4 col-sm-4 col-6">
													<img src="images/profile/3.jpg" alt="" class="img-fluid">
												</a>
												<a href="images/profile/4.jpg" data-exthumbimage="images/profile/4.jpg" data-src="images/profile/4.jpg" class="mb-1 col-lg-4 col-xl-4 col-sm-4 col-6">
													<img src="images/profile/4.jpg" alt="" class="img-fluid">
												</a>
												<a href="images/profile/3.jpg" data-exthumbimage="images/profile/3.jpg" data-src="images/profile/3.jpg" class="mb-1 col-lg-4 col-xl-4 col-sm-4 col-6">
													<img src="images/profile/3.jpg" alt="" class="img-fluid">
												</a>
												<a href="images/profile/4.jpg" data-exthumbimage="images/profile/4.jpg" data-src="images/profile/4.jpg" class="mb-1 col-lg-4 col-xl-4 col-sm-4 col-6">
													<img src="images/profile/4.jpg" alt="" class="img-fluid">
												</a>
												<a href="images/profile/2.jpg" data-exthumbimage="images/profile/2.jpg" data-src="images/profile/2.jpg" class="mb-1 col-lg-4 col-xl-4 col-sm-4 col-6">
													<img src="images/profile/2.jpg" alt="" class="img-fluid">
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-xl-12">
								<div class="card">
									<div class="card-body">
										<div class="profile-news">
											<h5 class="text-primary d-inline">Our Latest News</h5>
											<div class="media pt-3 pb-3">
												<img src="images/profile/5.jpg" alt="image" class="mr-3 rounded" width="75">
												<div class="media-body">
													<h5 class="m-b-5"><a href="post-details.html" class="text-black">Collection of textile samples</a></h5>
													<p class="mb-0">I shared this on my fb wall a few months back, and I thought.</p>
												</div>
											</div>
											<div class="media pt-3 pb-3">
												<img src="images/profile/6.jpg" alt="image" class="mr-3 rounded" width="75">
												<div class="media-body">
													<h5 class="m-b-5"><a href="post-details.html" class="text-black">Collection of textile samples</a></h5>
													<p class="mb-0">I shared this on my fb wall a few months back, and I thought.</p>
												</div>
											</div>
											<div class="media pt-3 pb-3">
												<img src="images/profile/7.jpg" alt="image" class="mr-3 rounded" width="75">
												<div class="media-body">
													<h5 class="m-b-5"><a href="post-details.html" class="text-black">Collection of textile samples</a></h5>
													<p class="mb-0">I shared this on my fb wall a few months back, and I thought.</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
                    </div>
                    <div class="col-xl-8">
                        <div class="card">
                            <div class="card-body">
                                <div class="profile-tab">
                                    <div class="custom-tab-1">
                                        <ul class="nav nav-tabs">
                                            <li class="nav-item"><a href="#my-posts" data-toggle="tab" class="nav-link active show">Posts</a>
                                            </li>
                                            <li class="nav-item"><a href="#about-me" data-toggle="tab" class="nav-link">About Me</a>
                                            </li>
                                            <li class="nav-item"><a href="#profile-settings" data-toggle="tab" class="nav-link">Setting</a>
                                            </li>
                                        </ul>
                                        <div class="tab-content">
                                            <div id="my-posts" class="tab-pane fade active show">
                                                <div class="my-post-content pt-3">
                                                    <div class="post-input">
                                                        <textarea name="textarea" id="textarea" cols="30" rows="5" class="form-control bg-transparent" placeholder="Please type what you want...."></textarea> 
														<a href="javascript:void(0);" class="btn btn-primary light px-3" data-toggle="modal" data-target="#linkModal"><i class="fa fa-link m-0"></i> </a>
														
														<div class="modal fade" id="linkModal">
															<div class="modal-dialog modal-dialog-centered" role="document">
																<div class="modal-content">
																	<div class="modal-header">
																		<h5 class="modal-title">Social Links</h5>
																		<button type="button" class="close" data-dismiss="modal"><span>&times;</span>
																		</button>
																	</div>
																	<div class="modal-body">
																		<a class="btn-social facebook" href="javascript:void(0)"><i class="fa fa-facebook"></i></a>
																		<a class="btn-social google-plus" href="javascript:void(0)"><i class="fa fa-google-plus"></i></a>
																		<a class="btn-social linkedin" href="javascript:void(0)"><i class="fa fa-linkedin"></i></a>
																		<a class="btn-social instagram" href="javascript:void(0)"><i class="fa fa-instagram"></i></a>
																		<a class="btn-social twitter" href="javascript:void(0)"><i class="fa fa-twitter"></i></a>
																		<a class="btn-social youtube" href="javascript:void(0)"><i class="fa fa-youtube"></i></a>
																		<a class="btn-social whatsapp" href="javascript:void(0)"><i class="fa fa-whatsapp"></i></a>
																	</div>
																</div>
															</div>
														</div>
                                                        <a href="javascript:void(0);" class="btn btn-primary light mr-1 px-3" data-toggle="modal" data-target="#cameraModal"><i class="fa fa-camera m-0"></i> </a>
														
														<div class="modal fade" id="cameraModal">
															<div class="modal-dialog modal-dialog-centered" role="document">
																<div class="modal-content">
																	<div class="modal-header">
																		<h5 class="modal-title">Upload images</h5>
																		<button type="button" class="close" data-dismiss="modal"><span>&times;</span>
																		</button>
																	</div>
																	<div class="modal-body">
																		<div class="input-group mb-3">
																			<div class="input-group-prepend">
																				<span class="input-group-text">Upload</span>
																			</div>
																			<div class="custom-file">
																				<input type="file" class="custom-file-input">
																				<label class="custom-file-label">Choose file</label>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
														<a href="javascript:void(0);" class="btn btn-primary" data-toggle="modal" data-target="#postModal">Post</a>
														
														<div class="modal fade" id="postModal">
															<div class="modal-dialog modal-dialog-centered" role="document">
																<div class="modal-content">
																	<div class="modal-header">
																		<h5 class="modal-title">Post</h5>
																		<button type="button" class="close" data-dismiss="modal"><span>&times;</span>
																		</button>
																	</div>
																	<div class="modal-body">
																		 <textarea name="textarea" id="textarea2" cols="30" rows="5" class="form-control bg-transparent" placeholder="Please type what you want...."></textarea>
																		 <a class="btn btn-primary btn-rounded" href="javascript:void(0)">Post</a>																		 
																	</div>
																</div>
															</div>
														</div>
                                                    </div>
                                                    <div class="profile-uoloaded-post border-bottom-1 pb-5">
                                                        <img src="images/profile/8.jpg" alt="" class="img-fluid w-100">
														<a class="post-title" href="post-details.html"><h3 class="text-black">Collection of textile samples lay spread</h3></a>
                                                        <p>A wonderful serenity has take possession of my entire soul like these sweet morning of spare which enjoy whole heart.A wonderful serenity has take possession of my entire soul like these sweet morning
                                                            of spare which enjoy whole heart.</p>
                                                        <button class="btn btn-primary mr-2"><span class="mr-2"><i class="fa fa-heart"></i></span>Like</button>
                                                        <button class="btn btn-secondary" data-toggle="modal" data-target="#replyModal"><span class="mr-2"><i class="fa fa-reply"></i></span>Reply</button>
                                                    </div>
                                                    <div class="profile-uoloaded-post border-bottom-1 pb-5">
                                                        <img src="images/profile/9.jpg" alt="" class="img-fluid w-100">
														<a class="post-title" href="post-details.html"><h3 class="text-black">Collection of textile samples lay spread</h3></a>
                                                        <p>A wonderful serenity has take possession of my entire soul like these sweet morning of spare which enjoy whole heart.A wonderful serenity has take possession of my entire soul like these sweet morning
                                                            of spare which enjoy whole heart.</p>
                                                        <button class="btn btn-primary mr-2"><span class="mr-2"><i class="fa fa-heart"></i></span>Like</button>
                                                        <button class="btn btn-secondary" data-toggle="modal" data-target="#replyModal"><span class="mr-2"><i class="fa fa-reply"></i></span>Reply</button>
                                                    </div>
                                                    <div class="profile-uoloaded-post pb-3">
                                                        <img src="images/profile/8.jpg" alt="" class="img-fluid w-100">
														<a class="post-title" href="post-details.html"><h3 class="text-black">Collection of textile samples lay spread</h3></a>
                                                        <p>A wonderful serenity has take possession of my entire soul like these sweet morning of spare which enjoy whole heart.A wonderful serenity has take possession of my entire soul like these sweet morning
                                                            of spare which enjoy whole heart.</p>
                                                        <button class="btn btn-primary mr-2"><span class="mr-2"><i class="fa fa-heart"></i></span>Like</button>
                                                        <button class="btn btn-secondary" data-toggle="modal" data-target="#replyModal"><span class="mr-2"><i class="fa fa-reply"></i></span>Reply</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="about-me" class="tab-pane fade">
                                                <div class="profile-about-me">
                                                    <div class="pt-4 border-bottom-1 pb-3">
                                                        <h4 class="text-primary">About Me</h4>
                                                        <p class="mb-2">A wonderful serenity has taken possession of my entire soul, like these sweet mornings of spring which I enjoy with my whole heart. I am alone, and feel the charm of existence was created for the bliss of souls like mine.I am so happy, my dear friend, so absorbed in the exquisite sense of mere tranquil existence, that I neglect my talents.</p>
                                                        <p>A collection of textile samples lay spread out on the table - Samsa was a travelling salesman - and above it there hung a picture that he had recently cut out of an illustrated magazine and housed in a nice, gilded frame.</p>
                                                    </div>
                                                </div>
                                                <div class="profile-skills mb-5">
                                                    <h4 class="text-primary mb-2">Skills</h4>
                                                    <a href="javascript:void(0);" class="btn btn-primary light btn-xs mb-1">Admin</a>
                                                    <a href="javascript:void(0);" class="btn btn-primary light btn-xs mb-1">Dashboard</a>
                                                    <a href="javascript:void(0);" class="btn btn-primary light btn-xs mb-1">Photoshop</a>
                                                    <a href="javascript:void(0);" class="btn btn-primary light btn-xs mb-1">Bootstrap</a>
                                                    <a href="javascript:void(0);" class="btn btn-primary light btn-xs mb-1">Responsive</a>
                                                    <a href="javascript:void(0);" class="btn btn-primary light btn-xs mb-1">Crypto</a>
                                                </div>
                                                <div class="profile-lang  mb-5">
                                                    <h4 class="text-primary mb-2">Language</h4>
													<a href="javascript:void(0);" class="text-muted pr-3 f-s-16"><i class="flag-icon flag-icon-us"></i> English</a> 
													<a href="javascript:void(0);" class="text-muted pr-3 f-s-16"><i class="flag-icon flag-icon-fr"></i> French</a>
                                                    <a href="javascript:void(0);" class="text-muted pr-3 f-s-16"><i class="flag-icon flag-icon-bd"></i> Bangla</a>
                                                </div>
                                                <div class="profile-personal-info">
                                                    <h4 class="text-primary mb-4">Personal Information</h4>
                                                    <div class="row mb-2">
                                                        <div class="col-sm-3 col-5">
                                                            <h5 class="f-w-500">Name <span class="pull-right">:</span>
                                                            </h5>
                                                        </div>
                                                        <div class="col-sm-9 col-7"><span>Mitchell C.Shay</span>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-2">
                                                        <div class="col-sm-3 col-5">
                                                            <h5 class="f-w-500">Email <span class="pull-right">:</span>
                                                            </h5>
                                                        </div>
                                                        <div class="col-sm-9 col-7"><span><a href="/cdn-cgi/l/email-protection" class="__cf_email__" data-cfemail="a9ccd1c8c4d9c5cce9ccd1c8c4d9c5ccc587cac6c4">[email&#160;protected]</a></span>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-2">
                                                        <div class="col-sm-3 col-5">
                                                            <h5 class="f-w-500">Availability <span class="pull-right">:</span></h5>
                                                        </div>
                                                        <div class="col-sm-9 col-7"><span>Full Time (Free Lancer)</span>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-2">
                                                        <div class="col-sm-3 col-5">
                                                            <h5 class="f-w-500">Age <span class="pull-right">:</span>
                                                            </h5>
                                                        </div>
                                                        <div class="col-sm-9 col-7"><span>27</span>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-2">
                                                        <div class="col-sm-3 col-5">
                                                            <h5 class="f-w-500">Location <span class="pull-right">:</span></h5>
                                                        </div>
                                                        <div class="col-sm-9 col-7"><span>Rosemont Avenue Melbourne,
                                                                Florida</span>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-2">
                                                        <div class="col-sm-3 col-5">
                                                            <h5 class="f-w-500">Year Experience <span class="pull-right">:</span></h5>
                                                        </div>
                                                        <div class="col-sm-9 col-7"><span>07 Year Experiences</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="profile-settings" class="tab-pane fade">
                                                <div class="pt-3">
                                                    <div class="settings-form">
                                                        <h4 class="text-primary">Account Setting</h4>
                                                        <form>
                                                            <div class="form-row">
                                                                <div class="form-group col-md-6">
                                                                    <label>Email</label>
                                                                    <input type="email" placeholder="Email" class="form-control">
                                                                </div>
                                                                <div class="form-group col-md-6">
                                                                    <label>Password</label>
                                                                    <input type="password" placeholder="Password" class="form-control">
                                                                </div>
                                                            </div>
                                                            <div class="form-group">
                                                                <label>Address</label>
                                                                <input type="text" placeholder="1234 Main St" class="form-control">
                                                            </div>
                                                            <div class="form-group">
                                                                <label>Address 2</label>
                                                                <input type="text" placeholder="Apartment, studio, or floor" class="form-control">
                                                            </div>
                                                            <div class="form-row">
                                                                <div class="form-group col-md-6">
                                                                    <label>City</label>
                                                                    <input type="text" class="form-control">
                                                                </div>
                                                                <div class="form-group col-md-4">
                                                                    <label>State</label>
                                                                    <select class="form-control default-select" id="inputState">
                                                                        <option selected="">Choose...</option>
                                                                        <option>Option 1</option>
                                                                        <option>Option 2</option>
                                                                        <option>Option 3</option>
                                                                    </select>
                                                                </div>
                                                                <div class="form-group col-md-2">
                                                                    <label>Zip</label>
                                                                    <input type="text" class="form-control">
                                                                </div>
                                                            </div>
                                                            <div class="form-group">
                                                                <div class="custom-control custom-checkbox">
																	<input type="checkbox" class="custom-control-input" id="gridCheck">
																	<label class="custom-control-label" for="gridCheck"> Check me out</label>
																</div>
                                                            </div>
                                                            <button class="btn btn-primary" type="submit">Sign
                                                                in</button>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
									
									<div class="modal fade" id="replyModal">
										<div class="modal-dialog modal-dialog-centered" role="document">
											<div class="modal-content">
												<div class="modal-header">
													<h5 class="modal-title">Post Reply</h5>
													<button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
												</div>
												<div class="modal-body">
													<form>
														<textarea class="form-control" rows="4">Message</textarea>
													</form>
												</div>
												<div class="modal-footer">
													<button type="button" class="btn btn-danger light" data-dismiss="modal">Close</button>
													<button type="button" class="btn btn-primary">Reply</button>
												</div>
											</div>
										</div>
									</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
	  <!--**********************************
	  Content body end
  ***********************************-->
	</div>
  </template>
  
<script>
import axios from "axios";
import 'vue-search-select/dist/VueSearchSelect.css'
import { ModelListSelect } from "vue-search-select"

import useVuelidate from "@vuelidate/core";
import { required, email, integer } from "@vuelidate/validators";
import { reactive, computed } from "vue";
  
  export default {
	name: "Profilee",
	components: { ModelListSelect },
	setup() {
    const state = reactive({
      errors: [],
      success: [],
      first_name: "",
      last_name: "",
      email: "",
      roles: "",
    });

    const rules = computed(() => {
      return {
        first_name: { required },
        last_name: { required },
        roles: { required, integer },
        email: { required, email },
        // mobile: { required, integer, minLength: minLength(10), maxLength: maxLength(10) },
      };
    });
    const v$ = useVuelidate(rules, state);

    return { state, v$ };
  },
  data() {
    return {

      opportunitiesDetails: "",
      contactsDetails: "",

      accountOwners: "",
      note_detail: [],
      task_detail: [],

      accountDetails: [],
      company: "",
      contact_details: "",
      phone: "",
      mobile_phone: "",
      note: [],
      task: [],
      address: "",
      Id: this.$route.params.id,

      related_contact:'',

      loading: false,
      loadingS: true,
      value_L: false,
      value_T: true,
      loadingSaveNewTaskText: true,
      loadingSaveNewTaskLoader: false,
      loadingSaveNewNoteText: true,
      loadingSaveNewNoteLoader: false,
    };
  },
  computed: {
    lan(){
      return this.$store.getters.whichLanguage
    },
	user(){
		return JSON.parse(localStorage.getItem("user"));
	},
    accountDetailsFilter() {
      var data = []
      // var self = this;
      console.log('element')
      var roles = this.state.roles == '2' ? "Partner"   : this.state.roles == '3' ? "Customer" : 1
      if(this.state.roles != ""){
        this.accountDetails.forEach(element => {
          console.log(element)
          if(element.type == roles && (element.is_outside_partner != '1' ||element.is_outside_partner != 1))
          data.push(element);
        });
      }else{
        data = this.accountDetails
      }
      return data
    },
  },
  mounted() {
     // for top load page
     window.scrollTo(0, 0);
     
    this.related_contact = this.user.id
    console.log('tt-', typeof this.related_contact)
    this.getAccount_contact_oppo();
    axios
      .get(axios.defaults.baseURL + "contact/" + this.user.id, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        console.log("res", res);
        this.contact_details = res.data.data[0];

        this.state.first_name = res.data.data[0].first_name;
        this.state.last_name = res.data.data[0].last_name;
        this.state.email = res.data.data[0].email;
        this.phone = res.data.data[0].phone;
        this.company = res.data.data[0].company;
        this.note_detail= res.data.data[0].note_detail
        this.task_detail = res.data.data[0].task_detail
        // this.note = res.data.data[0].note;
        // this.task = res.data.data[0].task;

        this.mobile_phone = res.data.data[0].mobile_phone;
        this.state.roles = res.data.data[0].roles;
        this.address = res.data.data[0].address;
      })
      .catch((err) => {
        console.log("err", err);
        this.$store.dispatch("checkErrorAndSendToast", [
          err.response,
          "error",
        ]);
      });

    //************** Account owner details
    axios
      .get(axios.defaults.baseURL + "get-account-owners", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        this.accountOwners = res.data.data;
        console.log("account owners", this.accountOwners);
      })
      .catch((err) => {
        console.log("err account owner", err);
        this.$store.dispatch("checkErrorAndSendToast", [
          err.response,
          "error",
        ]);
      });
  },
  methods: {
    getName(item) {
        return `${item.name}`
    },
    editNote(id) {
      localStorage.setItem("editID", id);
      this.$router.push({ name: "Edit Note", params: { id: id }, });
    },
    editTask(id) {
      localStorage.setItem("editID", id);
      this.$router.push({ name: "Edit Task", params: { id: id }, });
    },
    getAccount_contact_oppo() {
      // *************GET Accounts**********
      axios
        .get(axios.defaults.baseURL + "accounts", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.accountDetails = res.data.data;
        })
        .catch((err) => {
          console.log("err", err);
          this.$store.dispatch("checkErrorAndSendToast", [
          err.response,
          "error",
        ]);
        });
    },
    submit() {

      this.v$.first_name.$touch();
      this.v$.last_name.$touch();
      this.v$.email.$touch();
      this.v$.roles.$touch();
      if (
        !this.v$.first_name.$invalid&&
        !this.v$.last_name.$invalid &&
        !this.v$.email.$invalid &&
        !this.v$.roles.$invalid
      ) {
        (this.loading = true), (this.loadingS = false);
        var formData = new FormData();
        formData.append("first_name", this.state.first_name);
        formData.append("last_name", this.state.last_name);
        formData.append("email", this.state.email);
        formData.append("phone", this.phone);
        formData.append("company", this.company);
        formData.append("mobile_phone", this.mobile_phone);
        formData.append("roles", this.state.roles);
        formData.append("address", this.address);
        formData.append("password", this.contact_details.password);
        formData.append("confirm_password", this.contact_details.confirm_password);
        if (this.note.length) {
          formData.append("note", JSON.stringify(this.note));
        } else {
          formData.append("note", this.note);
        }
        if (this.task.length) {
          formData.append("task", JSON.stringify(this.task));
        } else {
          formData.append("task", this.task);
        }

        axios
          .post(axios.defaults.baseURL + "edit-contact/" + this.user.id, formData, {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          })
          .then((res) => {
            console.log("res", res);
            (this.loading = false),
              (this.loadingS = true),
              this.$store.dispatch("checkErrorAndSendToast", [res,'Success']);
          })
          .catch((err) => {
            (this.loading = false),
            (this.loadingS = true),
            this.$store.dispatch("checkErrorAndSendToast", [err.response,'error']);
          });
      } else {
        console.log("else", this.v$);
        this.AddToast("Please Fill Required Details", " info ", "info_1");
        return;
      }
    },
    saveNewNoteHandle(data) {
      this.note.push(data.note_id,)
      this.note_detail.push({
        note_id: data.note_id,
        subject: data.subject,
        comment: data.comment,
      });
    },
    saveNewTaskHandle(data) {
      this.task.push(data.task_id),
      this.task_detail.push({
        task_id: data.task_id,
        subject: data.subject,
        assign_to: data.assign_to,
        comment: data.comment,
      });
    },

    route() {
      console.log("recfgh");
      this.$router.push("/contacts");
    },
    deletef(){
      this.value_L = true
      this.value_T = false
      axios
      .post(axios.defaults.baseURL + "delete-contact/" + this.Id ,{}, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        this.value_L = false
      this.value_T = true
        this.AddToast(res.data.message, " Success ", "success_1");
        document.getElementById('deletemodal').click();
        this.$router.push({ path: "/contacts" });
      })
      .catch((err) => {
        this.$store.dispatch("checkErrorAndSendToast", [
          err.response,
          "error",
        ]);
        this.value_L = false
      this.value_T = true
      });
    },

    AddToast(message, title, type) {
      this.$store.commit("addToast", {
        title: title,
        type: type,
        message: message,
      });
      setTimeout(() => {
        this.dismissToast(title);
      }, 5000);
    },
    dismissToast(title) {
      this.$store.commit("clearToast", title);
    },
  }
  };
  </script>
  
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped></style>
  